import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { ResourcesService } from '../../../services/resources.service';
import { DatePipe } from '@angular/common';
import { isEmpty } from 'rxjs';
import { ModalComponent } from '../../shared/modal/modal.component';

@Component({
  selector: 'app-resource',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.scss'],
    providers: [
      DatePipe
    ]
})
export class ResourceComponent implements OnInit {

  resource: any = {};
  listRoutes: any = [];
  listManageEngine: any = [];
  listAdo: any = [];
  listChapter: any = [
    { value: 'Java Development', text: 'Java Development' },
    { value: 'Salesforce Development', text: 'Salesforce Development' },
    { value: 'Mulesoft Development', text: 'Mulesoft Development' },
    { value: 'Quality Assurance', text: 'Quality Assurance' },
    { value: 'Project Management', text: 'Project Management' }
  ];

  listPrimaryTask: any = [
    {value: 'Development', text: 'Development'},
    {value: 'Design', text: 'Design'},
    {value: 'Quality Assurance', text: 'Quality Assurance'},
    {value: 'Project Management', text: 'Project Management'},
    {value: 'Support', text: 'Support'}
  ]

  listType : any = [
    {value: 'CAPEX', text: 'CAPEX'},
    {value: 'OPEX', text: 'OPEX'}
  ]

  listCapexCode : any = [
    {value : '08.29', text: 'BSS - FABRICA DE SOFTWARE BSS	08.29'},
    {value : '08.26', text: 'INFRA IT - OTROS INFRAESTRUCTURA IT	08.26'},
    {value : '08.42', text: 'BI Y ANAYLTICS - OTROS BI Y ANALYTICS	08.42'},
    {value : '08.38', text: 'ERP - FABRICA DE SOFTWARE ERP	08.38'},
    {value : '08.47', text: 'OTROS IT - OTROS FABRICA DE SOFTWARE	08.47'},
    {value : '08.14', text: 'OTROS IT - SEGURIDAD Y CONTROL	08.14'}
  ]

  listTeam: any = [];
  listVendor: any = [];
  listContract: any = [];

  constructor(
    private __ref: DynamicDialogRef,
    private __resourcesService : ResourcesService,
    private __datePipe: DatePipe,
    private __config: DynamicDialogConfig,
    private __dialogService : DialogService,
  ) {

  }

  ngOnInit(): void {
    this.getListResources();
    this.getListManageEngine();
    this.getListAdo();
    this.getListTeam();
    this.getListVendor();
    this.getListContract();
    if (!this.isEmpty(this.__config.data.item)) {
      this.resource = this.__config.data.item;
      this.resource.IDRESOURCE = this.resource.RESOURCE_ID;
    } else {
      this.resource.IDRESOURCE = 0;
    }
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  getListResources() {
    //this.__spinner.show({ type: 'loader' });
    this.listRoutes = [];
    this.__resourcesService.getListRoutes().subscribe((resp: any) => {
      this.listRoutes = resp.listRoutes;
      //.__spinner.close();
    });
  }

  getListManageEngine() {
    //this.__spinner.show({ type: 'loader' });
    this.listManageEngine = [];
    this.__resourcesService.getListManageEngine().subscribe((resp: any) => {
      this.listManageEngine = resp.listManageEngine;
      //.__spinner.close();
    });
  }

  getListAdo() {
    //this.__spinner.show({ type: 'loader' });
    this.listAdo = [];
    this.__resourcesService.getListAdo().subscribe((resp: any) => {
      this.listAdo = resp.listAdoMappingRsrc;
      //.__spinner.close();
    });
  }

  getListTeam() {
    this.listTeam = [];
    this.__resourcesService.getListTeam().subscribe((resp: any) => {
      this.listTeam = resp.listData;
    });
  }

  getListVendor() {
    this.listVendor = [];
    this.__resourcesService.getListVendor().subscribe((resp: any) => {
      this.listVendor = resp.listData;
    });
  }

  getListContract() {
    this.listContract = [];
    this.__resourcesService.getListContract().subscribe((resp: any) => {
      this.listContract = resp.listData;
    });
  }


  selectItem(event: any) {
    console.log(event);
    let item = this.listRoutes.find((e: any) => e.OneLoginID == event);
    this.resource.USEREMAIL = item.WORK_CONTACT_WORK_EMAIL;
    this.resource.ADP_DEPARTMENT = (item.ADP_DEPARTMENT = "Information Technology") ? "IT" : null;
    this.resource.DEPARTMENT = (item.ADP_DEPARTMENT = "Information Technology") ? "IT" : null;
    this.resource.ADP_ID = item.TABLEAU_ID;
    this.resource.START_DATE = this.__datePipe.transform(item.HIRE_DATE, 'd/M/yy');
    this.resource.ACTIVE = (item.STATUS = "Active") ? 'TRUE' : 'FALSE';
  }

  saveResources() {
    //this.__spinner.show({ type: 'loader' });
    if (this.resource.USERNAME == undefined || this.resource.ACTIVE == undefined || this.resource.EMPLOYER == undefined ||
      this.resource.CONTRACT == undefined || this.resource.ADPLEVEL == undefined || this.resource.BILLABLE == undefined ||
      this.resource.UNIT == undefined || this.resource.EXTERNAL == undefined || this.resource.TEAM == undefined) {
        this.onShowMessage();
      return;
    }
    if (this.resource.USERNAME?.length == 0 || this.resource.ACTIVE?.length == 0 || this.resource.EMPLOYER?.length == 0 ||
      this.resource.CONTRACT?.length == 0 || this.resource.ADPLEVEL?.length == 0 || this.resource.BILLABLE?.length == 0 ||
      this.resource.UNIT?.length == 0 || this.resource.EXTERNAL?.length == 0 || this.resource.TEAM?.length == 0) {
        this.onShowMessage();
      return;
    }
    this.__resourcesService.saveResources(this.resource).subscribe((resp: any) => {
      if(+resp?.an_resultado==0) {
        //this.__spinner.close();
        this.accept();
      }
    });
  }

  onShowMessage() {
    let confirm = this.__dialogService.open(ModalComponent, {
      width: '30%',
      header: 'Complete fields required',
      dismissableMask: false,
      closable: false,
    });

    confirm?.onClose.subscribe((resp: any) => {
    });
  }

  cancel() {
    let data = {
      accion: 'cancel'
    }
    this.__ref.close(data);
  }

  accept() {
    let data = {
      accion: 'success'
    }
    this.__ref.close(data);
  }

}
